// extracted by mini-css-extract-plugin
export default {"entityrelation":"EntityRelationSidebar_entityrelation__KengS"};